import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnDirective, ColumnsDirective } from './columns.directive';
import { AggregateColumnDirective, AggregateColumnsDirective } from './aggregate-columns.directive';
import { AggregateDirective, AggregatesDirective } from './aggregates.directive';
import { GridComponent } from './grid.component';
import { GridModule } from './grid.module';
import {Filter, Page, Selection, Sort, Group, Reorder, RowDD, DetailRow, Toolbar, Aggregate, Search, VirtualScroll, Edit, Resize, ExcelExport, PdfExport, CommandColumn, ContextMenu, Freeze, ColumnMenu, ColumnChooser, ForeignKey, BlazorAction, InfiniteScroll, LazyLoadGroup} from '@syncfusion/ej2-grids';


export const /** @type {?} */ FilterService: ValueProvider = { provide: 'GridsFilter', useValue: Filter};
export const /** @type {?} */ PageService: ValueProvider = { provide: 'GridsPage', useValue: Page};
export const /** @type {?} */ SelectionService: ValueProvider = { provide: 'GridsSelection', useValue: Selection};
export const /** @type {?} */ SortService: ValueProvider = { provide: 'GridsSort', useValue: Sort};
export const /** @type {?} */ GroupService: ValueProvider = { provide: 'GridsGroup', useValue: Group};
export const /** @type {?} */ ReorderService: ValueProvider = { provide: 'GridsReorder', useValue: Reorder};
export const /** @type {?} */ RowDDService: ValueProvider = { provide: 'GridsRowDD', useValue: RowDD};
export const /** @type {?} */ DetailRowService: ValueProvider = { provide: 'GridsDetailRow', useValue: DetailRow};
export const /** @type {?} */ ToolbarService: ValueProvider = { provide: 'GridsToolbar', useValue: Toolbar};
export const /** @type {?} */ AggregateService: ValueProvider = { provide: 'GridsAggregate', useValue: Aggregate};
export const /** @type {?} */ SearchService: ValueProvider = { provide: 'GridsSearch', useValue: Search};
export const /** @type {?} */ VirtualScrollService: ValueProvider = { provide: 'GridsVirtualScroll', useValue: VirtualScroll};
export const /** @type {?} */ EditService: ValueProvider = { provide: 'GridsEdit', useValue: Edit};
export const /** @type {?} */ ResizeService: ValueProvider = { provide: 'GridsResize', useValue: Resize};
export const /** @type {?} */ ExcelExportService: ValueProvider = { provide: 'GridsExcelExport', useValue: ExcelExport};
export const /** @type {?} */ PdfExportService: ValueProvider = { provide: 'GridsPdfExport', useValue: PdfExport};
export const /** @type {?} */ CommandColumnService: ValueProvider = { provide: 'GridsCommandColumn', useValue: CommandColumn};
export const /** @type {?} */ ContextMenuService: ValueProvider = { provide: 'GridsContextMenu', useValue: ContextMenu};
export const /** @type {?} */ FreezeService: ValueProvider = { provide: 'GridsFreeze', useValue: Freeze};
export const /** @type {?} */ ColumnMenuService: ValueProvider = { provide: 'GridsColumnMenu', useValue: ColumnMenu};
export const /** @type {?} */ ColumnChooserService: ValueProvider = { provide: 'GridsColumnChooser', useValue: ColumnChooser};
export const /** @type {?} */ ForeignKeyService: ValueProvider = { provide: 'GridsForeignKey', useValue: ForeignKey};
export const /** @type {?} */ BlazorActionService: ValueProvider = { provide: 'GridsBlazorAction', useValue: BlazorAction};
export const /** @type {?} */ InfiniteScrollService: ValueProvider = { provide: 'GridsInfiniteScroll', useValue: InfiniteScroll};
export const /** @type {?} */ LazyLoadGroupService: ValueProvider = { provide: 'GridsLazyLoadGroup', useValue: LazyLoadGroup};
/**
 * NgModule definition for the Grid component with providers.
 */
export class GridAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, GridModule],
    exports: [
        GridModule
    ],
    providers:[
        FilterService,
        PageService,
        SelectionService,
        SortService,
        GroupService,
        ReorderService,
        RowDDService,
        DetailRowService,
        ToolbarService,
        AggregateService,
        SearchService,
        VirtualScrollService,
        EditService,
        ResizeService,
        ExcelExportService,
        PdfExportService,
        CommandColumnService,
        ContextMenuService,
        FreezeService,
        ColumnMenuService,
        ColumnChooserService,
        ForeignKeyService,
        BlazorActionService,
        InfiniteScrollService,
        LazyLoadGroupService
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GridAllModule_tsickle_Closure_declarations() {
/** @type {?} */
GridAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GridAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
